module.exports = __webpack_public_path__ + "static/img/af40f24745edc9b0f6797173b2bec5f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv1.png
// module id = EJu4
// module chunks = 1